import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Icon from "./Icon/Icon";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, [pathname]);

  return <Icon />;
};

export default ScrollToTop;
